import { jsPDF } from "jspdf";
import { drawFreshEarthSeal } from "./pdfLogo";

const FOREST = [26, 43, 34];
const TERRA = [184, 101, 81];
const BONE = [247, 246, 240];
const INK = [28, 28, 28];
const SLATE = [92, 94, 85];
const STONE = [138, 140, 130];

// Branded one-page capability overview, personalised for an official / place.
export function generateCapabilityPdf(context = "", name = "") {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = 595;
  const M = 48;

  const preparedFor = [name, context].filter(Boolean).join(" · ");

  // Header
  doc.setFillColor(...FOREST);
  doc.rect(0, 0, W, 128, "F");
  drawFreshEarthSeal(doc, { x: M, y: 32, size: 68, tone: "light" });
  doc.setTextColor(...BONE);
  doc.setFont("times", "italic");
  doc.setFontSize(26);
  doc.text("Fresh Earth", M + 82, 62);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(220, 224, 214);
  doc.text("OED — Odour Eliminator & Decomposer", M + 82, 82);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...TERRA);
  doc.text("CAPABILITY OVERVIEW", W - M, 54, { align: "right" });
  if (preparedFor) {
    doc.setFont("helvetica", "normal");
    doc.setTextColor(220, 224, 214);
    doc.text(`Prepared for ${preparedFor}`, W - M, 72, { align: "right" });
  }

  let y = 170;
  doc.setTextColor(...INK);
  doc.setFont("times", "normal");
  doc.setFontSize(24);
  doc.text("Biological landfill & organic-waste remediation", M, y);
  y += 22;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...SLATE);
  const intro =
    "OED is a scalable indigenous microbial bio-solution (4x10^12 microbes/ml) derived from native Indian cow dung and urine. It eliminates landfill odour, accelerates decomposition, reduces methane and restores biological activity to waste ecosystems.";
  doc.text(doc.splitTextToSize(intro, W - 2 * M), M, y);

  // Key results
  y += 66;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(...STONE);
  doc.text("PROVEN RESULTS", M, y);
  y += 8;
  doc.setDrawColor(210, 210, 200);
  doc.line(M, y, W - M, y);
  y += 20;

  const results = [
    ["100%", "odour control within a week (95% day one)"],
    ["up to 70%", "weight reduction of treated waste"],
    ["3-4 weeks", "decomposition vs 3-4 months naturally"],
    ["+20-30%", "biogas increase in Bio-CNG applications"],
    ["2.25 lakh MT", "legacy waste bio-mined at Bhubaneswar (BMC)"],
    ["15", "municipal corporations deployed across 6 states"],
  ];
  doc.setFontSize(11);
  results.forEach(([v, l]) => {
    doc.setFont("times", "normal");
    doc.setTextColor(...FOREST);
    doc.text(v, M, y);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...SLATE);
    doc.text(l, M + 110, y);
    y += 22;
  });

  // Applications
  y += 12;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(...STONE);
  doc.text("APPLICATIONS", M, y);
  y += 8;
  doc.line(M, y, W - M, y);
  y += 20;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...SLATE);
  const apps =
    "Legacy landfills & dumpsites  |  Bio-mining  |  RDF / cement plants  |  Bio-CNG  |  STP / wastewater  |  Food, dairy & poultry waste  |  Public sanitation";
  doc.text(doc.splitTextToSize(apps, W - 2 * M), M, y);

  // Trust band
  y += 52;
  doc.setFillColor(...TERRA);
  doc.roundedRect(M, y, W - 2 * M, 72, 10, 10, "F");
  doc.setTextColor(...BONE);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("TRUSTED BY", M + 20, y + 26);
  doc.setFont("times", "normal");
  doc.setFontSize(15);
  doc.text("UltraTech Cement · Dalmia · ACC · Reliance Bio-Energy · BMC · Puri", M + 20, y + 52);

  // Footer
  doc.setDrawColor(210, 210, 200);
  doc.line(M, 792, W - M, 792);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...STONE);
  doc.text("Fresh Earth · Exotic Buildcon SPV LLP  |  +91 98995 34141  |  care@fresh-earth.com", M, 808);
  doc.text("ISO 14001:2015 · Aligned with Swachh Bharat Mission", M, 820);

  const filenameTag = [name, context].filter(Boolean).join("-").replace(/[\s,]+/g, "");
  doc.save(`FreshEarth-OED-Capability${filenameTag ? "-" + filenameTag : ""}.pdf`);
}
